import { Box, Flex, Heading, IconButton } from '@chakra-ui/react';
import { BiPrinter, BiTrash } from 'react-icons/bi';
import { GoTriangleDown } from 'react-icons/go';
import { MdAddCircle } from 'react-icons/md';
import Select from 'react-select';

import { DealMediaStatusEnum } from '../../../constants/media';

export interface MediaFilter {
  label: string;
  value: DealMediaStatusEnum;
}

interface MediaCenterHeaderProps {
  filterValue: MediaFilter;
  onAddMedia: () => void;
  onDelete: () => void;
  onFilter: (value: MediaFilter) => void;
  onPrint: () => void;
  canDelete: boolean;
}

const selectOptions = Object.entries(DealMediaStatusEnum).map(([key, value]) => ({
  label: key,
  value,
}));

const MediaCenterHeader = ({
  canDelete,
  filterValue,
  onAddMedia,
  onDelete,
  onFilter,
  onPrint,
}: MediaCenterHeaderProps) => {
  return (
    <>
      <Box backgroundColor="oxfordBlue" borderRadius="10px 10px 0 0">
        <Box alignItems="center" display="flex" justifyContent="space-between" px={4} py={2}>
          <Heading color="white" fontSize="20px" fontWeight="medium">
            Media Center
          </Heading>
          <Flex alignItems="center" justifyContent="end" flexWrap="wrap" gap={1}>
            <Select
              components={{
                DropdownIndicator: () => (
                  <Box color="primary" mr={2}>
                    <GoTriangleDown size={20} />
                  </Box>
                ),
              }}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              onChange={(val) => onFilter(val!)}
              options={selectOptions}
              styles={{
                container: (base) => ({
                  ...base,
                  zIndex: 2,
                }),
                control: (base) => ({
                  ...base,
                  minWidth: '130px',
                }),
                indicatorSeparator: (base) => ({
                  ...base,
                  backgroundColor: 'white',
                }),
              }}
              value={filterValue}
            />

            <Flex>
              <IconButton
                icon={<BiTrash />}
                variant="icon"
                color={canDelete ? 'errorsRed' : 'gray.500'}
                fontSize={32}
                aria-label="Delete Media"
                cursor={canDelete ? 'pointer' : 'not-allowed'}
                onClick={() => {
                  if (canDelete) {
                    onDelete();
                  }
                }}
              />

              <IconButton
                icon={<BiPrinter />}
                variant="icon"
                fontSize={32}
                aria-label="Print Media"
                onClick={onPrint}
              />

              <IconButton
                icon={<MdAddCircle />}
                variant="icon"
                fontSize={32}
                aria-label="Upload Media"
                onClick={onAddMedia}
              />
            </Flex>
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export default MediaCenterHeader;
